import * as styles from "./TabsList.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Tabs as BaseTabs } from "@base-ui/react/tabs";

import { useTabsContext } from "./Tabs.context";
import type { TabsListProps } from "./Tabs.types";

export function TabsList({
  className,
  sticky = false,
  ...props
}: TabsListProps): JSX.Element {
  const { variant, orientation } = useTabsContext();

  return (
    <BaseTabs.List
      data-slot="tabs-list"
      className={clsx(styles.list({ variant, orientation, sticky }), className)}
      {...props}
    />
  );
}
